import logo from './logo.svg';
import './App.css';
import React, { useState, useEffect } from "react";
import axios from "axios";
import FormWithLocalStorage from './components/Form';
//import TableWithLocalStorage from './components/Table';
import Upcoming from './components/Upcoming';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import "react-big-calendar/lib/css/react-big-calendar.css";
//import MyCalendar from './components/MyCalendar';
//import { useEffect, useState } from "react";
import { Calendar, dateFnsLocalizer } from 'react-big-calendar'
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import startOfWeek from 'date-fns/startOfWeek'
import getDay from 'date-fns/getDay'
import enUS from 'date-fns/locale/en-US'
import { monthsInQuarter } from 'date-fns/constants'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import timezone from 'dayjs/plugin/timezone'
import { TZ as APP_TIMEZONE } from './config/timezone';

dayjs.extend(utc)
dayjs.extend(advancedFormat)
dayjs.extend(customParseFormat)
dayjs.extend(timezone)
const TZ = APP_TIMEZONE || 'America/Chicago';
//import myEventsList from './myEventsList'
//import items from './Form'
//import willthisworkforme from './Form'
//comment not needed
//import myEventsList from './myEventsList'

const EVENTS_API_URL = '/api/events';

function App() {
   // const [users, setUsers] = useState([]);
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [fetchError, setFetchError] = useState(null);
    const [activeTab, setActiveTab] = useState('chill-request');
    const [upcomingSubTab, setUpcomingSubTab] = useState('power-rangers');
    const [peopleSubTab, setPeopleSubTab] = useState('people-list');
    const [unlockCode, setUnlockCode] = useState('');
    const [unlockError, setUnlockError] = useState('');
    const [isUnlocked, setIsUnlocked] = useState(() => {
      return typeof window !== 'undefined' && sessionStorage.getItem('chilzy_unlocked') === 'true';
    });


    /*
    useEffect(() => {
      fetch("http://localhost:5001/api/users")
        .then(res => res.json())
        .then(data => setUsers(data))
        .catch((err) => console.error("Error:", err));
    }, []);
*/
    const fetchEvents = () => {
      setLoading(true);
      setFetchError(null);
      fetch(EVENTS_API_URL)
        .then(async (res) => {
          const text = await res.text().catch(() => null);
          let body = null;
          try { body = text ? JSON.parse(text) : null; } catch (e) { body = text; }
          if (!res.ok) {
            console.error('API error response body:', body);
            throw new Error(body && body.error ? `${body.error}: ${body.details || ''}` : `API returned ${res.status}`);
          }
          return body;
        })
        .then(data => setEvents(data || []))
        .catch((err) => {
          console.error("Error:", err);
          setFetchError(err.message || 'Fetch error');
        })
        .finally(() => setLoading(false));
    };

    useEffect(() => {
      fetchEvents();
    }, []);

    const unlockUpcoming = () => {
      if (unlockCode.trim() === '1010') {
        sessionStorage.setItem('chilzy_unlocked', 'true');
        setIsUnlocked(true);
        setUnlockError('');
      } else {
        setUnlockError('Incorrect code. Try again.');
      }
    };




  const formatTimeRange = (evt) => {
    // Build dayjs datetimes from date + optional time (uses shared buildDateTime)
    const startDT = buildDateTime(evt.start_date, evt.start_time);
    const endDT = buildDateTime(evt.end_date, evt.end_time) || startDT;

    if (!startDT) return 'TBD';

    const fmtCompact = (d) => {
      if (!d || !d.isValid()) return '';
      const m = d.minute();
      const h = d.format('h');
      const ampm = d.format('a');
      if (m === 0) return `${h} ${ampm}`; // e.g. 6pm
      return `${h}:${d.format('mm')} ${ampm}`; // e.g. 8:30 pm
    }

    // Single-day: show times only on second line (caller will render date on first)
    if (startDT.isSame(endDT, 'day')) {
      const s = fmtCompact(startDT);
      const e = endDT && !startDT.isSame(endDT) ? fmtCompact(endDT) : null;
      return e ? `${s} to ${e}` : s;
    }

    // Multi-day: return combined date+time range
    return `${startDT.format('M/D h:mm A')} - ${endDT.format('M/D h:mm A')}`;
  }
// Parse date parts (YYYY-MM-DD) and construct local Date objects
const parseDateParts = (dateRaw) => {
  if (!dateRaw) return null;
  const datePart = dateRaw.includes('T') ? dateRaw.split('T')[0] : dateRaw;
  const parts = datePart.split('-').map(Number);
  if (parts.length < 3) return null;
  return { year: parts[0], month: parts[1], day: parts[2] };
};

const parseLocalDateTime = (dateRaw, timeStr) => {
  // Interpret stored date (+ optional stored time) as America/Chicago local
  if (!dateRaw) return null;
  const datePart = dateRaw.includes('T') ? dateRaw.split('T')[0] : dateRaw;
  const timePart = timeStr || '00:00:00';
  const ts = timePart.length === 5 ? `${timePart}:00` : timePart;
  const fmt = 'YYYY-MM-DD HH:mm:ss';
  const dt = dayjs.tz(`${datePart} ${ts}`, fmt, TZ);
  return dt.isValid() ? dt.toDate() : null;
};

const transformedEvents = events.map(data => ({
  title: data.name,
  start: parseLocalDateTime(data.start_date, data.start_time),
  end: parseLocalDateTime(data.end_date || data.start_date, data.end_time),
}));

  // Move buildDateTime out so other helpers can use it (returns a dayjs wrapper)
  const buildDateTime = (dateRaw, timeStr) => {
    // Return a dayjs object anchored to America/Chicago for consistent formatting
    if (!dateRaw && !timeStr) return null;
    const datePart = dateRaw ? (dateRaw.includes('T') ? dateRaw.split('T')[0] : dateRaw) : null;
    const timePart = timeStr || '00:00:00';
    const ts = timePart.length === 5 ? `${timePart}:00` : timePart;
    const fmt = 'YYYY-MM-DD HH:mm:ss';
    const dt = datePart ? dayjs.tz(`${datePart} ${ts}`, fmt, TZ) : null;
    return dt && dt.isValid() ? dt : null;
  };
    // Helpers for display formatting (dates + times)
    const formatDateRange = (startRaw, endRaw, evt) => {
      if (!startRaw) return '';
      const start = buildDateTime(startRaw, evt?.start_time) || buildDateTime(startRaw, null);
      const end = endRaw ? (buildDateTime(endRaw, evt?.end_time) || buildDateTime(endRaw, null)) : start;

      // helper for compact time (minutes only if not zero)
      const fmtCompact = (d) => {
        if (!d || !d.isValid()) return '';
        const m = d.minute();
        const h = d.format('h');
        const ampm = d.format('a');
        if (m === 0) return `${h} ${ampm}`; // e.g. 6pm
        return `${h}:${d.format('mm')} ${ampm}`; // e.g. 8:30 pm
      }

      // Single-day: first line date, second line times
      if (start && end && start.isSame(end, 'day')) {
        const times = evt ? formatTimeRange(evt) : '';
        return (
          <>
            <div>{start.format('MMMM Do')}</div>
            <div>{times}</div>
          </>
        );
      }

      // Multi-day: show start and end with times on separate lines
      const startDT = buildDateTime(startRaw, evt?.start_time);
      const endDT = buildDateTime(endRaw, evt?.end_time) || startDT;
      const s = startDT && startDT.isValid() ? fmtCompact(startDT) : '';
      const e = endDT && endDT.isValid() ? fmtCompact(endDT) : '';
      return (
        <>
          <div>{`Starts at ${s} on ${start ? start.format('MMMM Do') : ''}`}</div>
          <div>{`Ends at ${e} on ${end ? end.format('MMMM Do') : ''}`}</div>
        </>
      );
    }

    const formatDayPill = (startRaw, endRaw) => {
    if (!startRaw) return '';
    const parseDateOnly = (raw) => {
      if (!raw) return null;
      const datePart = raw.includes('T') ? raw.split('T')[0] : raw;
      return dayjs.tz(datePart, 'YYYY-MM-DD', TZ);
    };
    const start = parseDateOnly(startRaw);
    const end = endRaw ? parseDateOnly(endRaw) : start;
    if (!start || !start.isValid()) return '';
    if (start.isSame(end, 'day')) {
      return start.format('dddd');
    }
    return `Starts ${start.format('dddd')}`;
  }


    const eventData = 
    [
    {
      'title': 'testing',
    'allDay': true,
      'start': new Date(2025, 10, 7),
     'end': new Date(2025, 10, 7 )
   }
  ]

  const locales = {
    'en-US': enUS,
  }
  
  const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
  })
  
    return (
      <div className="app-container">
        <header className="brand-header">
          <div className="brand-logo">
            <span className="brand-mark">✦</span>
            Chilzy
          </div>
          <p className="brand-tagline">World-class chill planning with premium flow and effortless vibes.</p>
        </header>
        {/* <section>
         <h2>Test section</h2> 
          {loading ? (
            <p>Loading events...</p>
          ) : fetchError ? (
            <p style={{ color: 'red' }}>Error loading events: {fetchError}</p>
          ) : events.length > 0 ? (
            <ul>
              {events.map((event) => (
                <li key={event.id || `${event.name}-${event.start_date}`}>
                  <strong>{event.name}</strong> — {event.start_date} {event.start_time} @ {event.location || 'No location'}
                  {event.email ? ` (email: ${event.email})` : ''}
                </li>
              ))}
            </ul>
          ) : (
            <p>No events found.</p>
          )}
        </section>
*/}

 {/*<Upcoming></Upcoming>  */}

{/*<MyCalendar></MyCalendar>*/}



{activeTab === 'chill-request' && <FormWithLocalStorage onEventAdded={fetchEvents} />}

{activeTab === 'upcoming' && (
  <section className="upcoming-section">
    {!isUnlocked ? (
      <div className="unlock-screen">
        <h2>Unlock Upcoming Chills</h2>
        <p>Enter the access code to view your upcoming events.</p>
        <div className="unlock-form">
          <input
            type="password"
            value={unlockCode}
            onChange={(e) => setUnlockCode(e.target.value)}
            placeholder="Access code"
          />
          <button type="button" onClick={unlockUpcoming}>
            Unlock
          </button>
        </div>
        {unlockError && <p className="unlock-error">{unlockError}</p>}
      </div>
    ) : (
      <>
        <div className="section-tabs">
          <button
            type="button"
            onClick={() => setUpcomingSubTab('power-rangers')}
            className={`section-tab ${upcomingSubTab === 'power-rangers' ? 'active' : ''}`}
          >
            List View
          </button>
          <button
            type="button"
            onClick={() => setUpcomingSubTab('ninja-turtles')}
            className={`section-tab ${upcomingSubTab === 'ninja-turtles' ? 'active' : ''}`}
          >
            Calendar
          </button>
        </div>

        {upcomingSubTab === 'power-rangers' && (
          <div className="event-grid">
            {events.length ? events.map((e, index) => (
              <article key={e.id || index} className="event-card">
                <div className="event-card-top">
                  <span className="event-chip">{formatDayPill(e.start_date, e.end_date)}</span>
                  <span className="event-chip event-chip-secondary">{e.location || 'Anywhere'}</span>
                </div>
                <h2 className="event-card-title">{e.name || 'Untitled Chill'}</h2>
                <p className="event-card-meta">{formatDateRange(e.start_date, e.end_date, e)}</p>
                <div className="event-card-footer">
                  <span className="event-pill">Placeholder</span>
                </div>
              </article>
            )) : (
              <div className="no-upcoming-message">There are no upcoming chills</div>
            )}
          </div>
        )}

        {upcomingSubTab === 'ninja-turtles' && (
          <div className="calendar-wrapper">
            <Calendar
              localizer={localizer}
              events={transformedEvents}
              startAccessor="start"
              endAccessor="end"
              style={{ height: 520, borderRadius: '24px', overflow: 'hidden', background: '#ffffff' }}
            />
          </div>
        )}
      </>
    )}
  </section>
)}

{activeTab === 'calendar' && (
  <section className="upcoming-section">
    <div className="section-tabs">
      <button
        type="button"
        onClick={() => setUpcomingSubTab('people-list')}
        className={`section-tab ${upcomingSubTab === 'people-list' ? 'active' : ''}`}
      >
        Individuals
      </button>
      <button
        type="button"
        onClick={() => setUpcomingSubTab('group-list')}
        className={`section-tab ${upcomingSubTab === 'group-list' ? 'active' : ''}`}
      >
        Groups
      </button>
    </div>
    {upcomingSubTab === 'people-list' && (
      <div className="event-grid">
        {events.slice(0, 4).map((e, index) => (
          <article key={e.id || index} className="event-card">
            <div className="event-card-top">
              <span className="event-chip">{e.location || 'Remote'}</span>
              <span className="event-chip event-chip-secondary">{e.start_time || 'TBD'}</span>
            </div>
            <h2 className="event-card-title">{e.name || 'Chill Experience'}</h2>
            <p className="event-card-meta">{e.start_date || 'Upcoming date'}</p>
            <div className="event-card-footer">
              <span className="event-pill">7 spots</span>
              <span className="event-pill">Live now</span>
            </div>
          </article>
        ))}
      </div>
    )}
    {upcomingSubTab === 'group-list' && (
      <div className="group-grid">
        <div className="group-card">
          <h2>Weekend Squad</h2>
          <p>4 events lined up, top-rated chill creators, and group RSVP.</p>
          <span className="event-pill">High energy</span>
        </div>
        <div className="group-card">
          <h2>Midweek Smooth</h2>
          <p>Relaxed sessions with curated playlists and easy check-ins.</p>
          <span className="event-pill">Low drama</span>
        </div>
      </div>
    )}
  </section>
)}

<div className="bottom-nav">
  <div className="bottom-nav-inner">
    <button
      onClick={() => setActiveTab('chill-request')}
      className={`bottom-nav-button ${activeTab === 'chill-request' ? 'active' : ''}`}
    >
      Chill Request
    </button>
    <button
      onClick={() => setActiveTab('upcoming')}
      className={`bottom-nav-button ${activeTab === 'upcoming' ? 'active' : ''}`}
    >
      Upcoming Chills
    </button>
  </div>
</div>


      
{/*
        <h1>Users</h1>
        <ul>
          {users.map(u => <li key={u.id}>{u.name} - {u.email}</li>)}
        </ul>
        */}
      </div>
    );
  }
  

  export default App;
